export const SVG_NS = "http://www.w3.org/2000/svg";
/**
 * Helper function to easily create HTML elements without passing the correct
 * namespace
 * @param qualifiedName
 * @param ownerDocument the document to use for element creation
 * @returns the element
 */
export const createHTMLElement = (qualifiedName, ownerDocument) => {
    return ownerDocument.createElement(qualifiedName);
};
/**
 * Helper function to easily create SVG elements without passing the correct
 * namespace
 * @param qualifiedName
 * @param ownerDocument the document to use for element creation
 * @returns the element
 */
export const createSVGElement = (qualifiedName, ownerDocument) => {
    const elem = ownerDocument.createElementNS(SVG_NS, qualifiedName);
    if (qualifiedName === "svg") {
        elem.setAttribute("xmlns", SVG_NS);
    }
    return elem;
};
